"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
/**
 * A renderer can be registered to a #MapHelper to determine how a plottable object is to be applied
 */
class Renderer {
    constructor() {
        this._debug_1 = 'color:#fff;background-color:orange;';
        this._debug_2 = 'color:#fff;background-color:#666;';
    }
    _log(id = 'constructor', data = null) {
        if (id == 'constructor')
            return; // hide constructor logging for now
        if (id == 'onAdd') {
            if (data && data[0]) {
                data[0]['__renderer'] = this.constructor.name;
            }
            if (data && data[1]) {
                data[0]['__renderer_args'] = data[1];
            }
        }
        // console.log ( '%c '+this.constructor.name+' %c '+id+' ', this._debug_1, this._debug_2, data ? data : '' );
    }
    onAdd(obj, args) {
        throw new Error("Not implemented");
    }
    onUpdate(obj, pr, args) {
        return rxjs_1.of(pr);
    }
    onRemove(obj, pr) {
        throw new Error("Not implemented");
    }
    destory() { }
    monitorEvent(id, event) {
        return;
        const c = event.constructor.name + ':' + id;
        const me = this;
        if (event) {
            // me._log('addEventListener ['+c+']' );
            event.addEventListener(function (aa, bb, cc) {
                me._log('eventListener [' + c + '] result', [aa, bb, cc]);
            });
        }
    }
}
exports.Renderer = Renderer;
